import React, { Fragment, useMemo } from "react";
import ReactModal from "react-modal";

export default function AppModal(props) {
	const overlayClassName = useMemo(
		() =>
			[
				"app-modal modal fade",
				props.isOpen ? "show" : "",
				props.isDialogBox ? "dialogbox" : "",
				!props.isDialogBox && props.isActionSheet ? "action-sheet" : "",
				props.overlayClassName ? props.overlayClassName : "",
			]
				.filter((c) => c !== "")
				.join(" "),
		[props.isOpen, props.isDialogBox, props.isActionSheet, props.overlayClassName]
	);
	const dialogClassName = `app-modal__dialog modal-dialog ${props.className ? props.className : ""}`;

	return (
		<Fragment>
			<ReactModal
				closeTimeoutMS={500}
				isOpen={props.isOpen}
				contentLabel={props.contentLabel}
				overlayClassName={overlayClassName}
				className={dialogClassName}
				bodyOpenClassName="modal-open"
				ariaHideApp={false}
				style={{ overlay: { ...(props.isOpen && { display: "block" }) }, content: { outline: 0 } }}
				shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
				{...(props.onRequestClose && {
					onRequestClose: props.onRequestClose,
				})}
			>
				<div className="modal-content">
					{props.prependContent && props.prependContent}
					{props.modalHeader && <div className="modal-header">{props.modalHeader}</div>}
					<div className="modal-body">
						{props.isActionSheet ? (
							<div className="action-sheet-content mb-2">{props.children}</div>
						) : (
							props.children
						)}
					</div>
					{props.modalFooter && <div className="modal-footer">{props.modalFooter}</div>}
					{props.appendContent && props.appendContent}
				</div>
			</ReactModal>
			{props.isOpen && <div className="app-modal__backdrop modal-backdrop fade show" />}
		</Fragment>
	);
}

AppModal.defaultProps = {
	contentLabel: "App Modal",
	isDialogBox: false,
	prependContent: undefined,
	appendContent: undefined,
	modalHeader: undefined,
	modalFooter: undefined,
};
